module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.49c56daa.otf";